const api = (command, vendorIds, purposeIds, legitimateInterestPurposeIds) => new Promise((resolve, reject) => {
    if (window.__tcfapi) {
        window.__tcfapi(command, 2, (result, success) => success ? resolve(result) : (
        /* istanbul ignore next */
        reject(new Error(`Unable to get ${command} data`))), vendorIds, purposeIds, legitimateInterestPurposeIds);
    }
    else {
        reject(new Error("No __tcfapi found on window"));
    }
});
const getTCData = () => api("addEventListener");
const getCustomVendorConsents = () => api("getCustomVendorConsents");
export { getCustomVendorConsents, getTCData };
